import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { WhatsAppConversationMessagesResponse } from "../../aiConversations.types";
import {
  AiConversationSubRoute,
  ApiRoutesAiConversations
} from "../../constants/enums";
import { GetConversationMessagesParams } from "./getConversationMessages.types";

export const requestGetConversationMessages = async ({
  conversationId,
  ...params
}: GetConversationMessagesParams): Promise<WhatsAppConversationMessagesResponse> => {
  return await instance.get(
    buildUrl(
      ApiRoutesAiConversations.Conversations,
      conversationId,
      AiConversationSubRoute.Messages
    ),
    { params }
  );
};
